import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BodyText,
  Box,
  Heading,
  SkeletonLoader,
} from '@chargify/custom-ui-components';

import { Header } from '../../ComponentsAllocationEdit.styles';

const ComponentsAllocationEditSkeleton = () => {
  const { t } = useTranslation(['subscriptions-manager']);

  return (
    <div>
      <Box marginBottom={4}>
        <Header>
          <Heading variant="h4">
            {t('components_allocations.recurring_addons')}
          </Heading>
          <BodyText variant="body1">
            {t('components_allocations.charged_every_cycle')}
          </BodyText>
        </Header>
      </Box>
      <Box marginBottom={6}>
        <SkeletonLoader height={100} />
      </Box>
      <Box marginBottom={4}>
        <Header>
          <Heading variant="h4">
            {t('components_allocations.one_time_addons')}
          </Heading>
          <BodyText variant="body1">
            {t('components_allocations.charged_once')}
          </BodyText>
        </Header>
      </Box>
      <Box>
        <SkeletonLoader height={100} />
      </Box>
    </div>
  );
};

export default ComponentsAllocationEditSkeleton;
